import * as React from 'react';
import { useFormikContext } from 'formik';

import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

import EventProcedureFormFields from './FormFields';
import NewStepModalFormik from './NewStepModalFormik';
import StepLibraryFormik from './StepLibraryFormik';

import EventProcedureStepForm from '../EventProcedureStepForm';

function FormBase() {
  const { values } = useFormikContext<EventProceduresAPIType<Array<EventProcedureStepAPIType>>>();

  const [showNewStepModal, setShowNewStepModal] = React.useState<boolean>(false);
  const [showFromLibraryModal, setShowFromLibraryModal] = React.useState<boolean>(false);
  const [showViewStepModal, setShowViewStepModal] = React.useState<boolean>(false);
  const [stepToView, setStepToView] = React.useState<EventProcedureStepAPIType>();

  const handleOnNewStep = () => {
    setShowFromLibraryModal(false);
    setShowViewStepModal(false);
    setShowNewStepModal(true);
  };

  const handleFromLibrary = () => {
    setShowViewStepModal(false);
    setShowNewStepModal(false);
    setShowFromLibraryModal(true);
  };

  const handleViewStep = (stepId: string) => {
    const selectedStep = values.steps.find(
      (ep: EventProceduresAPIType<Array<EventProcedureStepAPIType>>) => ep.id === stepId,
    );
    setStepToView(selectedStep);
    setShowNewStepModal(false);
    setShowFromLibraryModal(false);
    setShowViewStepModal(true);
  };

  return (
    <>
      <EventProcedureFormFields
        onNewStep={handleOnNewStep}
        onFromLibrary={handleFromLibrary}
        onViewStep={handleViewStep}
      />
      {showNewStepModal && <NewStepModalFormik onClose={() => setShowNewStepModal(false)} />}
      {showFromLibraryModal && <StepLibraryFormik onClose={() => setShowFromLibraryModal(false)} />}
      {showViewStepModal && (
        <EventProcedureStepForm
          eventProcedureStep={stepToView}
          onClose={() => {
            setShowViewStepModal(false);
            setStepToView(undefined);
          }}
          readOnly
        />
      )}
    </>
  );
}

export default FormBase;
